import React from "react";
import { IconProps } from "./utils";

export const BankCard = React.forwardRef<SVGSVGElement, IconProps>(
  ({ className, size = 38, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      width={width || size}
      height={height || size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.74433 10.6668C3.36682 10.6668 3.17807 10.6668 3.03237 10.5902C2.90721 10.5244 2.8002 10.4127 2.73982 10.2848C2.66955 10.1359 2.67735 9.95486 2.69296 9.59275C2.73278 8.66885 2.83607 8.04327 3.10394 7.51753C3.48744 6.76489 4.09936 6.15296 4.85201 5.76947C5.70765 5.3335 6.82776 5.3335 9.06797 5.3335H22.9346C25.1748 5.3335 26.295 5.3335 27.1506 5.76947C27.9032 6.15296 28.5152 6.76489 28.8987 7.51753C29.1665 8.04327 29.2698 8.66885 29.3096 9.59275C29.3253 9.95486 29.3331 10.1359 29.2628 10.2848C29.2024 10.4127 29.0954 10.5244 28.9702 10.5902C28.8245 10.6668 28.6358 10.6668 28.2583 10.6668H3.74433ZM2.66797 14.4002C2.66797 14.0268 2.66797 13.8401 2.74063 13.6975C2.80455 13.5721 2.90653 13.4701 3.03198 13.4062C3.17458 13.3335 3.36127 13.3335 3.73463 13.3335H28.268C28.6413 13.3335 28.828 13.3335 28.9706 13.4062C29.0961 13.4701 29.1981 13.5721 29.262 13.6975C29.3346 13.8401 29.3346 14.0268 29.3346 14.4002V20.2668C29.3346 22.507 29.3346 23.6271 28.8987 24.4828C28.5152 25.2354 27.9032 25.8474 27.1506 26.2309C26.295 26.6668 25.1748 26.6668 22.9346 26.6668H9.06797C6.82776 26.6668 5.70765 26.6668 4.85201 26.2309C4.09936 25.8474 3.48744 25.2354 3.10394 24.4828C2.66797 23.6271 2.66797 22.507 2.66797 20.2668V14.4002ZM9.33464 18.6668C8.59826 18.6668 8.0013 19.2638 8.0013 20.0002C8.0013 20.7365 8.59826 21.3335 9.33464 21.3335H14.668C15.4043 21.3335 16.0013 20.7365 16.0013 20.0002C16.0013 19.2638 15.4043 18.6668 14.668 18.6668H9.33464Z"
        fill="currentColor"
      />
    </svg>
  )
);

BankCard.displayName = "GymReportIcon";
